<template>
	<div class="form__group">
		<textarea v-if="type == 'textarea'"
				  v-model="inputValue"
				  :type="type"
				  :name="name"
				  :placeholder="placeholder"
				  :maxlength="maxlength ? maxlength : false"
				  :required="required == 'true' ? 'required' : false"
				  @change.prevent="validate($event.target.value)"
		></textarea>
		<input v-else
			   v-model="inputValue"
			   :type="type"
			   :id="name"
			   :name="name"
			   :placeholder="placeholder"
			   :maxlength="maxlength ? maxlength : false"
			   :required="required == 'true' ? 'required' : false"
			   @change.prevent="validate($event.target.value)"
		>
		<button class="object-address" type="button"
		v-if="getLocation"
		@click.prevent="getLocationEvent"></button>

		<label v-if="label" :for="name"><span v-html="label"></span></label>
		<p class="form__errors" v-if="error" v-html="error"></p>
	</div>
</template>

<script>
	import axios from 'axios';

	export default {
		name:    'inquiry-input',
		props:   {
			name:        {
				type:     String,
				required: true
			},
			value:       {
				required: false,
			},
			label:       {
				type:     String,
			},
			type:        {
				type:    String,
				default: 'text'
			},
			required:    {
				type:     String,
				required: false
			},
			placeholder: {
				type:     String,
				required: false
			},
			maxlength:   {
				type:     String,
				required: false
			},
			error:       {
				required: false,
				default:  false
			},
			success:     {
				type:     String,
				required: false
			},

			getLocation: {
				type: Boolean,
				required: false,
			},

			location: {
				type: Object,
				required: false,
			},
		},
		data() {
			return {
				loading: false,
				xhr:     null,
				inputValue: this.value,
				inputError: false,
			};
		},

		methods: {
			updateError() {
				let error = this.inputError;
				let field = this.name;
				this.$emit('updateError', {
					field,
					error
				});
			},
			validate(value) {
				if(this.xhr && this.xhr.readyState != 4) {
					this.xhr.abort();
				}
				this.xhr = $.ajax({
					method:     'post',
					url:        document.environments.adminAjax,
					data:       {
						field:  this.name,
						value:  this.inputValue,
						action: 'validateInquiryField'
					},
					dataType:   'json',
					beforeSend: this.aBefore,
					success:    this.aSuccess,
					error:      this.aError,
					complete:   this.aComplete
				});
			},
			aBefore() {
				this.loading = true;
			},
			aSuccess: function(response) {
				this.inputError = false;
				let field  = this.name;
				let value  = this.inputValue;
				this.$emit('sendValueToParent', {
					field,
					value
				});
			},
			aError(xhr) {
				if(xhr.responseJSON) {
					this.inputError = xhr.responseJSON.error[this.name];
					let field       = this.name;
					let value       = this.inputValue;
					this.$emit('sendValueToParent', {
						field,
						value
					});
				}
			},
			aComplete() {
				this.updateError();
				this.loading = false;
			},

			getLocationEvent() {
				this.$getLocation({
					enableHighAccuracy: false,
					timeout:            Infinity,
					maximumAge:         0
				})
					.then(coordinates => {
						this.$emit('clickLocation', coordinates);
					})
					.catch(function(error) {
						window.alert(error);
					});
			},
		},

		watch: {
			location: {
				handler() {
					if(this.location.lat !== '' && this.location.lng !== '') {
						let latlon = 'lat=' + this.location.lat + '&lon=' +this.location.lng;
						axios.get('https://nominatim.openstreetmap.org/reverse?' + latlon + '&format=json')
						.then((response) => {
							const address = response.data.address;
							const road = address.road ? address.road: '';
							const houseNumber = address.house_number ? address.house_number: '';
							const postcode = address.postcode ? address.postcode : '';
							const city = address.city ? address.city: '';
							const suburb = address.suburb ? address.suburb: '';
							const country = address.country ? address.country : '';

							this.inputValue = road + (road !== '' && houseNumber !== '' ? ' ' : '')
							  + houseNumber + (road !== '' || houseNumber !== '' ? ', ' : '')
							  + postcode + (postcode !== '' && city !== '' ? ' ' : '')
							  + city + (city !== '' && suburb !== '' ? ', ' : '')
							  + suburb;

							let field       = this.name;
							let value       = this.inputValue;
							this.$emit('sendValueToParent', {
								field,
								value
							});
							this.validate(this.inputValue)
						});
					}
				},
				deep:    true
			}
		}
	};
</script>

<style scoped>

</style>